import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'DataResolutionPopupLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '35932428-2464-4112-a641-9c7a3c3eabfd',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: -25,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '2936f649-5d9e-494c-8b2f-ebe2948e1123',
      type: 'NineSlicePlane',
      name: 'bg',
      nameSpace: '',
      className: '',
      x: 0,
      y: 38,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 550,
        y: 340
      },
      width: 1100,
      height: 680,
      leftWidth: 100,
      topHeight: 300,
      rightWidth: 102,
      bottomHeight: 273,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_board',
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: '8b2eb643-6626-4119-b90a-7d4acfd24c03',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -253,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_title_bg',
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: 'b8640739-750a-4cbb-b906-44d3d710b637',
      type: 'Container',
      name: 'ChooseWrap',
      nameSpace: 'ChooseContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: '22d78360-d368-4242-bfce-0f0e3d38fd7b',
      type: 'Container',
      name: 'SelectWrap',
      nameSpace: 'SelectContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: '45f6e188-daae-4fab-8bd8-9f003810dd27',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'YourProgress',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '0x903030',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '8b2eb643-6626-4119-b90a-7d4acfd24c03',
      data: ''
    },
    {
      id: 'f647f38d-6b45-4075-8aa9-89e2abbd93c8',
      type: 'Sprite',
      name: 'button2bg',
      nameSpace: '',
      className: '',
      x: -262,
      y: 283,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_bg',
      parent: 'b8640739-750a-4cbb-b906-44d3d710b637',
      data: ''
    },
    {
      id: 'b1cc891b-7874-4db9-b4b2-304340462f52',
      type: 'Sprite',
      name: 'button1bg',
      nameSpace: '',
      className: '',
      x: 262,
      y: 283,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_bg',
      parent: 'b8640739-750a-4cbb-b906-44d3d710b637',
      data: ''
    },
    {
      id: '09bbc19b-8d71-4ab4-a745-bae206857b91',
      type: 'Sprite',
      name: 'SaveState1BG',
      nameSpace: 'SaveState1',
      className: '',
      x: -500,
      y: -80,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_preview',
      parent: 'b8640739-750a-4cbb-b906-44d3d710b637',
      data: ''
    },
    {
      id: 'a2aa8379-7fb4-4172-a571-25b40a5055db',
      type: 'Sprite',
      name: 'SaveState2BG',
      nameSpace: 'SaveState2',
      className: '',
      x: 23,
      y: -80,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_preview',
      parent: 'b8640739-750a-4cbb-b906-44d3d710b637',
      data: ''
    },
    {
      id: '48a930c4-f40a-4581-a349-f214e5eace23',
      type: 'Text',
      name: 'cloudProgressText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -179,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'DataConflictResolutionDescriptionFacebook',
      localize: true,
      maxWidth: 1002,
      maxHeight: 80,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3c2f',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'b8640739-750a-4cbb-b906-44d3d710b637',
      data: ''
    },
    {
      id: '3f59692d-fa90-4776-a4a9-5f3a3014e6e3',
      type: 'Sprite',
      name: 'SelectedSaveState',
      nameSpace: 'SelectedSave',
      className: '',
      x: -235,
      y: -80,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_preview',
      parent: '22d78360-d368-4242-bfce-0f0e3d38fd7b',
      data: ''
    },
    {
      id: '7cefd004-c7b7-4d68-a90d-8a996666af5e',
      type: 'Sprite',
      name: 'CancelBg',
      nameSpace: '',
      className: '',
      x: -262,
      y: 283,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_bg',
      parent: '22d78360-d368-4242-bfce-0f0e3d38fd7b',
      data: ''
    },
    {
      id: '6b21c4a3-e3a3-48b9-8c8f-98291cf78ace',
      type: 'Sprite',
      name: 'SelectedBtnBg',
      nameSpace: '',
      className: '',
      x: 262,
      y: 283,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_bg',
      parent: '22d78360-d368-4242-bfce-0f0e3d38fd7b',
      data: ''
    },
    {
      id: '464d2e90-6d39-450c-b016-7d434676f9f7',
      type: 'Text',
      name: 'restoreConfirmationText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -179,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'DataConflictResolutionConfirmationFacebook',
      localize: true,
      maxWidth: 1002,
      maxHeight: 80,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3c2f',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '22d78360-d368-4242-bfce-0f0e3d38fd7b',
      data: ''
    },
    {
      id: '0afa6ab3-9a19-4f11-9fc5-42f4971700c1',
      type: 'Sprite',
      name: 'selectSaveBtn2',
      nameSpace: '',
      className: '',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: 'f647f38d-6b45-4075-8aa9-89e2abbd93c8',
      data: ''
    },
    {
      id: '2fc01fdb-49ea-442c-ab9c-0b3c78bc990d',
      type: 'Sprite',
      name: 'selectSaveBtn1',
      nameSpace: '',
      className: '',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: 'b1cc891b-7874-4db9-b4b2-304340462f52',
      data: ''
    },
    {
      id: '57a7e3d0-b26e-459c-b8f4-742932aaf533',
      type: 'Sprite',
      name: 'frame',
      nameSpace: 'SaveState1',
      className: '',
      x: -16,
      y: -7,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_frame_beige',
      parent: '09bbc19b-8d71-4ab4-a745-bae206857b91',
      data: ''
    },
    {
      id: '5fd844b6-0d91-4dcb-9370-ee5a5fd28b29',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 265,
      y: 20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_level',
      parent: '09bbc19b-8d71-4ab4-a745-bae206857b91',
      data: ''
    },
    {
      id: '3131d065-a11d-49bd-b137-cc4113179e24',
      type: 'Text',
      name: 'descText',
      nameSpace: 'SaveState1',
      className: '',
      x: 265,
      y: 220,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'CloudProgress',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3c2f',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '09bbc19b-8d71-4ab4-a745-bae206857b91',
      data: ''
    },
    {
      id: 'b169dfe4-8723-436e-96df-1dcba7c54fc3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 22,
      y: 281,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_slot_beige',
      parent: '09bbc19b-8d71-4ab4-a745-bae206857b91',
      data: ''
    },
    {
      id: '8bd4c81f-bdcd-4814-b1b8-3ba34c6562c6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 504,
      y: 281,
      anchor: {
        x: 1,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_slot_beige',
      parent: '09bbc19b-8d71-4ab4-a745-bae206857b91',
      data: ''
    },
    {
      id: '483b579c-6531-4f02-8ab0-2697c70b868e',
      type: 'Sprite',
      name: 'frame',
      nameSpace: 'SaveState2',
      className: '',
      x: -16,
      y: -7,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_frame_beige',
      parent: 'a2aa8379-7fb4-4172-a571-25b40a5055db',
      data: ''
    },
    {
      id: '62b9c93c-9e85-4ac7-818e-1b081c859f34',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 265,
      y: 20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_level',
      parent: 'a2aa8379-7fb4-4172-a571-25b40a5055db',
      data: ''
    },
    {
      id: 'df14f637-275b-4f13-b592-a7eab82cb71c',
      type: 'Text',
      name: 'descText',
      nameSpace: 'SaveState2',
      className: '',
      x: 265,
      y: 220,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'CloudProgress',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3c2f',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'a2aa8379-7fb4-4172-a571-25b40a5055db',
      data: ''
    },
    {
      id: '6535a4c7-debb-4f1c-a84a-0e86fa195f68',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 22,
      y: 281,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_slot_beige',
      parent: 'a2aa8379-7fb4-4172-a571-25b40a5055db',
      data: ''
    },
    {
      id: '108db6bd-8a9b-4b0d-876b-45308f76538d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 504,
      y: 281,
      anchor: {
        x: 1,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_slot_beige',
      parent: 'a2aa8379-7fb4-4172-a571-25b40a5055db',
      data: ''
    },
    {
      id: 'cb228cfb-4899-4a5e-9310-d35f8dda0b9c',
      type: 'Sprite',
      name: 'frame',
      nameSpace: 'SaveState2',
      className: '',
      x: -16,
      y: -7,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_frame_beige',
      parent: '3f59692d-fa90-4776-a4a9-5f3a3014e6e3',
      data: ''
    },
    {
      id: '27ac2eea-f257-4f36-813a-f968c98bdee7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 265,
      y: 20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_level',
      parent: '3f59692d-fa90-4776-a4a9-5f3a3014e6e3',
      data: ''
    },
    {
      id: 'f962970d-8c54-4428-b764-f0fcd300954c',
      type: 'Text',
      name: 'descText',
      nameSpace: 'SaveState2',
      className: '',
      x: 265,
      y: 220,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'CloudProgress',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3c2f',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '3f59692d-fa90-4776-a4a9-5f3a3014e6e3',
      data: ''
    },
    {
      id: 'ad0f4bcf-7f0a-43dc-9cc7-f1bbfd74c356',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 22,
      y: 281,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_slot_beige',
      parent: '3f59692d-fa90-4776-a4a9-5f3a3014e6e3',
      data: ''
    },
    {
      id: '2ecf64f4-a109-423e-91c6-8c80c9703d15',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 504,
      y: 281,
      anchor: {
        x: 1,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_slot_beige',
      parent: '3f59692d-fa90-4776-a4a9-5f3a3014e6e3',
      data: ''
    },
    {
      id: 'e6cfe732-8e40-4397-8d3b-11503e031ff0',
      type: 'Sprite',
      name: 'CanceBtn',
      nameSpace: '',
      className: '',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_red',
      parent: '7cefd004-c7b7-4d68-a90d-8a996666af5e',
      data: ''
    },
    {
      id: '91055885-8e26-46b3-8bea-f67517eadaf8',
      type: 'Sprite',
      name: 'SelectedBtn',
      nameSpace: '',
      className: '',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: '6b21c4a3-e3a3-48b9-8c8f-98291cf78ace',
      data: ''
    },
    {
      id: '8167074b-6653-4767-963a-d9a3d90a8f30',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Choose',
      localize: true,
      maxWidth: 201,
      maxHeight: 71,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 54,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#3a7b0e',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '0afa6ab3-9a19-4f11-9fc5-42f4971700c1',
      data: ''
    },
    {
      id: 'aa94cda0-1c59-4e66-9410-3255cb04d3d9',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Choose',
      localize: true,
      maxWidth: 201,
      maxHeight: 71,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 54,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#3a7b0e',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2fc01fdb-49ea-442c-ab9c-0b3c78bc990d',
      data: ''
    },
    {
      id: '7d9c626e-e3d7-4804-864c-c132811b999b',
      type: 'Text',
      name: 'levelText',
      nameSpace: 'SaveState1',
      className: '',
      x: 0,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#83402a',
        strokeThickness: 8,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '5fd844b6-0d91-4dcb-9370-ee5a5fd28b29',
      data: ''
    },
    {
      id: '7da993c3-9a8a-4de0-81b1-2b1669c98c26',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 19,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin_icon',
      parent: 'b169dfe4-8723-436e-96df-1dcba7c54fc3',
      data: ''
    },
    {
      id: '9ac845fe-bc9a-4369-b96d-a9034d90b15f',
      type: 'Text',
      name: 'coinAmount',
      nameSpace: 'SaveState1',
      className: '',
      x: 125,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '123456789',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8c2218',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'b169dfe4-8723-436e-96df-1dcba7c54fc3',
      data: ''
    },
    {
      id: '5e040597-7838-4e51-8e80-b3f8a5c8839f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -197,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_star',
      parent: '8bd4c81f-bdcd-4814-b1b8-3ba34c6562c6',
      data: ''
    },
    {
      id: '0374af0b-d96b-401c-9368-272cf4f64a6a',
      type: 'Text',
      name: 'starAmount',
      nameSpace: 'SaveState1',
      className: '',
      x: -95,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '123456789',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8c2218',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '8bd4c81f-bdcd-4814-b1b8-3ba34c6562c6',
      data: ''
    },
    {
      id: '22f7cbf6-8edc-4477-9c3a-6852d2f49ce6',
      type: 'Text',
      name: 'levelText',
      nameSpace: 'SaveState2',
      className: '',
      x: 0,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#83402a',
        strokeThickness: 8,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '62b9c93c-9e85-4ac7-818e-1b081c859f34',
      data: ''
    },
    {
      id: 'c6c646ef-6577-46af-81dd-6be56ea5b9f9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 19,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin_icon',
      parent: '6535a4c7-debb-4f1c-a84a-0e86fa195f68',
      data: ''
    },
    {
      id: 'f5dc9aa2-33c5-4093-9674-450ef9131127',
      type: 'Text',
      name: 'coinAmount',
      nameSpace: 'SaveState2',
      className: '',
      x: 125,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '123456789',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8c2218',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '6535a4c7-debb-4f1c-a84a-0e86fa195f68',
      data: ''
    },
    {
      id: '379cf5b5-6324-4c43-8930-79bbb50dfb91',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -197,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_star',
      parent: '108db6bd-8a9b-4b0d-876b-45308f76538d',
      data: ''
    },
    {
      id: 'c028c75d-9ded-4fd7-a9be-fc36df52613b',
      type: 'Text',
      name: 'starAmount',
      nameSpace: 'SaveState2',
      className: '',
      x: -95,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '123456789',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8c2218',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '108db6bd-8a9b-4b0d-876b-45308f76538d',
      data: ''
    },
    {
      id: '94f5312d-acc3-479c-a027-47cb6178be0b',
      type: 'Text',
      name: 'levelText',
      nameSpace: 'SaveState2',
      className: '',
      x: 0,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#83402a',
        strokeThickness: 8,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '27ac2eea-f257-4f36-813a-f968c98bdee7',
      data: ''
    },
    {
      id: 'fe930067-f7c7-4871-aea5-fd06dce3ff2c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 19,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin_icon',
      parent: 'ad0f4bcf-7f0a-43dc-9cc7-f1bbfd74c356',
      data: ''
    },
    {
      id: '3e3f8609-6aef-47f2-9b59-d68535b4505a',
      type: 'Text',
      name: 'coinAmount',
      nameSpace: 'SaveState2',
      className: '',
      x: 125,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '123456789',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8c2218',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ad0f4bcf-7f0a-43dc-9cc7-f1bbfd74c356',
      data: ''
    },
    {
      id: '0f699e9b-6702-4576-b500-7c5194b57eb1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -197,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'savestate_star',
      parent: '2ecf64f4-a109-423e-91c6-8c80c9703d15',
      data: ''
    },
    {
      id: '6e2dafcc-8e14-4df5-821f-ea30bc0a30d7',
      type: 'Text',
      name: 'starAmount',
      nameSpace: 'SaveState2',
      className: '',
      x: -95,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '123456789',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8c2218',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2ecf64f4-a109-423e-91c6-8c80c9703d15',
      data: ''
    },
    {
      id: '41a3d589-1213-4425-88e5-7abd0f64972b',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Cancel',
      localize: true,
      maxWidth: 201,
      maxHeight: 71,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 54,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#992928',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e6cfe732-8e40-4397-8d3b-11503e031ff0',
      data: ''
    },
    {
      id: '8b1d4fc3-c96e-4806-a2bb-1769c0262c29',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Choose',
      localize: true,
      maxWidth: 201,
      maxHeight: 71,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 54,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#3a7b0e',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '91055885-8e26-46b3-8bea-f67517eadaf8',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class DataResolutionPopupLayout {
  static raw = raw;
  root: PIXI.Container
  bg: PIXI.NineSlicePlane
  ChooseWrap: PIXI.Container
  SelectWrap: PIXI.Container
  ChooseContainer: {
    button2bg: PIXI.Sprite
    selectSaveBtn2: PIXI.Sprite
    button1bg: PIXI.Sprite
    selectSaveBtn1: PIXI.Sprite
    SaveState1BG: PIXI.Sprite
    SaveState2BG: PIXI.Sprite
    cloudProgressText: PIXI.Text
    SaveState1: {
      frame: PIXI.Sprite
      levelText: PIXI.Text
      descText: PIXI.Text
      coinAmount: PIXI.Text
      starAmount: PIXI.Text
      SaveState1: {}
      children: (PIXI.Sprite | PIXI.Text)[]
    }
    SaveState2: {
      frame: PIXI.Sprite
      levelText: PIXI.Text
      descText: PIXI.Text
      coinAmount: PIXI.Text
      starAmount: PIXI.Text
      SaveState2: {}
      children: (PIXI.Sprite | PIXI.Text)[]
    }
    children: (PIXI.Sprite | PIXI.Text)[]
  }
  SelectContainer: {
    SelectedSaveState: PIXI.Sprite
    CancelBg: PIXI.Sprite
    CanceBtn: PIXI.Sprite
    SelectedBtnBg: PIXI.Sprite
    SelectedBtn: PIXI.Sprite
    restoreConfirmationText: PIXI.Text
    SelectedSave: {
      frame: PIXI.Sprite
      levelText: PIXI.Text
      descText: PIXI.Text
      coinAmount: PIXI.Text
      starAmount: PIXI.Text
      SaveState2: {}
      children: (PIXI.Sprite | PIXI.Text)[]
    }
    children: (PIXI.Sprite | PIXI.Text)[]
  }

  constructor() {
    populate(this, raw);
  }
}
